import { Icon } from 'antd';
import F from '../../../../Functions.js';


import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';


const NameCellRenderer = (params) => {
    const { first_name, last_name, phone, phone2 } = params.data;
    const { view } = params;

    const viewCustomer = (bfile_id) => {
        view(bfile_id);
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            {/* Name Row */}
            <a
                role="button"
                tabIndex="0"
                onClick={() => viewCustomer(params.data.id)} style={{ marginBottom: "-10px" }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      viewCustomer(params.data.id);
                    }
                  }}
                >
                <Icon type="user" style={{ marginRight: 10 }} />
                {first_name} {last_name} ▼
            </a>

            {phone && (
                <div style={{ marginBottom: "-16px" }}>
                    <Icon type="phone" style={{ marginRight: 10 }} /> <span>{F.phone_format(phone)}</span>
                </div>
            )}
            {phone2 && (
                <div >
                    <Icon type="phone" style={{ marginRight: 10 }} /> <span>{F.phone_format(phone2)}</span>
                </div>
            )}
        </div>
    );
};
export default NameCellRenderer;


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/reviewscheduler/name-cell-render.js